import API from '@/api'
import events from 'Store/events'
/**
 * Video Conference class
 */
export default class {
  constructor (data) {
    this.id = ~~data?.id
    this.name = data?.name || ''
    this.username = data?.username // extension
    this.users_count = data?.users?.length || 1
    this.users = data?.users || []
    this.admins = data?.admins || []
    this.adminsId = data?.admins?.map(admin => { return admin.id }) || [] // for create and update purposes
    this.usersId = data?.users?.map(user => { return user.id }) || [] // for create and update purposes
    this.phone_numbers = data?.phone_numbers || []
    this.expireAt = data?.expire_at ? new Date(data?.expire_at) : new Date()
    if (data?.expire_at) {
      this.expireAt = new Date(data?.expire_at)
    } else {
      const oneYearFromNow = new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate())
      this.expireAt = new Date(oneYearFromNow)
    }
    this.sharedScreenAdmin = data?.shared_screen_admin
    this.sharedScreenGuest = data?.shared_screen_guest
    this.recordingAdmin = data?.recording_admin
    this.recordingGuest = data?.recording_guest
    this.callerIdName = data?.caller_id_name
    this.callerIdNumber = data?.caller_id_number
    this.roomNumber = data?.room_number
    this.roomPin = data?.room_pin
    if (import.meta.env.NODE_ENV === 'production') {
      this.adminURL = data?.admin_url || ''
    } else {
      this.adminURL = API.baseURLPath(data?.admin_url)
    }
    if (import.meta.env.NODE_ENV === 'production') {
      this.guestURL = data?.guest_url || ''
    } else {
      this.guestURL = API.baseURLPath(data?.guest_url)
    }
    try {
      this.fullAdminURL = new URL(data?.full_admin_url)
    } catch {
      this.fullAdminURL = null
    }
    try {
      this.fullGuestURL = new URL(data?.full_guest_url)
    } catch {
      this.fullGuestURL = null
    }
  }

  get isValid () { return this.id > 0 && this.fullGuestURL !== null }

  get domain () {
    return this.fullGuestURL?.hostname
  }

  get URL () { return this.fullGuestURL.toString() }

  get jwt () {
    return this.fullGuestURL.searchParams.get('jwt') ?? ''
  }

  get jwtAdmin () {
    return this.fullAdminURL.searchParams.get('jwt') ?? ''
  }

  get roomHash () {
    const path = this.fullGuestURL.pathname.split('/')
    if (path.length < 2) {
      return ''
    }
    return path[1]
  }

  get jitsiRoom () {
    return `${this.name}_${this.roomHash}`
  }

  isAdmin (currentUsername) {
    return this.admins.some((user) => user.username === currentUsername)
  }

  getShortUrl (currentUsername) {
    return this.isAdmin(currentUsername) ? this.adminURL : this.guestURL
  }

  getJwt (currentUsername) {
    return this.isAdmin(currentUsername) ? this.jwtAdmin : this.jwt
  }

  copyGuestUrl () {
    const url = this.guestURL
    this.copyToClipboard(url)
      .then(() => events.pubNotify({ text: 'videoconf.msg.copy.success', status: 'success' }))
      .catch(() => events.pubError('videoconf.msg.copy.error'))
  }

  copyToClipboard (textToCopy) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy)
    }
    // text area method
    const textArea = document.createElement('textarea')
    textArea.value = textToCopy
    // make the textarea out of viewport
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise((resolve, reject) => {
      // here the magic happens
      document.execCommand('copy') ? resolve() : reject(new Error('fail to copy to clipboard'))
      textArea.remove()
    })
  }
}
